import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WidgetsModule } from '../../../widgets/widgets.module';
import { DateInputsModule } from '@progress/kendo-angular-dateinputs';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { EntityService } from '../../../tamalelibs/services/entity.service';
import { EntryService } from '../../../tamalelibs/services/entry.service';
import { AdvFilterHelperService } from '../../../tamalelibs/services/adv-filter-helper.service';
import { DateHelperService } from '../../../tamalelibs/services/date-helper.service';
import { LoggerService } from '../../../tamalelibs/services/logger.service';
import { ContactService } from '../../../tamalelibs/services/contact.service';
import { TemplateDialogService } from '../../template/template-dialog.service';
import { FileLookupService } from '../../../tamalelibs/services/file-lookup.service';
import { TemplateAliasComponent } from './template-alias/template-alias.component';
import { TagInputModule } from 'ngx-chips';
import { TemplateLabelComponent } from './template-label/template-label.component';
import { TemplateIconComponent } from './template-icon/template-icon.component';
import { TemplateAreaComponent } from './template-area/template-area.component';
import { TemplateDateComponent } from './template-date/template-date.component';
import { TemplateDividerComponent } from './template-divider/template-divider.component';
import { TemplateDropdownComponent } from './template-dropdown/template-dropdown.component';
import { TemplateInputComponent } from './template-input/template-input.component';
import { TemplateJobFunctionComponent } from './template-job-function/template-job-function.component';
import { TemplateMedComponent } from './template-med/template-med.component';
import { TemplateMsdComponent } from './template-msd/template-msd.component';
import { TemplateSingleDropdownComponent } from './template-single-dropdown/template-single-dropdown.component';
import { TemplateTextComponent } from './template-text/template-text.component';
import { TemplateBaseLayoutComponent } from './template-base-layout/template-base-layout.component';
import { TemplateCombineDropdownInputComponent } from './template-combine-dropdown-input/template-combine-dropdown-input.component';
import { TemplateAddressComponent } from './template-address/template-address.component';
import { TemplateFormerEmploymentComponent } from './template-former-employment/template-former-employment.component';

const components = [
    TemplateAliasComponent,
    TemplateLabelComponent,
    TemplateDateComponent,
    TemplateDividerComponent,
    TemplateTextComponent,
    TemplateAreaComponent,
    TemplateSingleDropdownComponent,
    TemplateInputComponent,
    TemplateIconComponent,
    TemplateDropdownComponent,
    TemplateMedComponent,
    TemplateJobFunctionComponent,
    TemplateMsdComponent,
    TemplateBaseLayoutComponent,
    TemplateCombineDropdownInputComponent,
    TemplateAddressComponent,
    TemplateFormerEmploymentComponent
];
@NgModule({
    imports: [
        CommonModule,
        WidgetsModule,
        DateInputsModule,
        DropDownsModule,
        TagInputModule,
    ],
    declarations: [
        ...components,
    ],
    exports: [
        ...components
    ],
    providers: [
        EntityService,
        EntryService,
        AdvFilterHelperService,
        DateHelperService,
        LoggerService,
        ContactService,
        TemplateDialogService,
        FileLookupService,
    ],
})
export class TemplateSettingLayoutModule {

}
